module.exports = __webpack_public_path__ + "static/media/QRcodeKingdom-appleStore.83f88dff.svg";